module.exports = __webpack_public_path__ + "static/media/vi_yan_yan.194beb11.png";